import React, { useState, useEffect } from "react";
import { ResponsivePie } from "@nivo/pie";
import Bridge from "../../constants/Bridge";
import $ from "jquery";

const AllDemographics = () => {
  const [portalReports, setPortalReports] = useState([]);
  const [totalOfPortalReport, setTotalOfPortalReport] = useState(0);

  useEffect(() => {
    getReportData();
  }, []);

  const getReportData = () => {
    Bridge.speech_study
      .all_demographics_chart_data()
      .then((result) => {
        if (result.status == "1") {
          setData(result.data);
        }
      })
      .catch((error) => {});
  };

  const setData = (data) => {
    let portalReports = [];
    let sum3 = 0;
    let duplicate = [];
    for (const item of data) {
      if (
        item.field == "DEMOG51" ||
        item.field == "DEMOG52" ||
        item.field == "DEMOG53" ||
        item.field == "DEMOG54" ||
        item.field == "DEMOG55" ||
        item.field == "DEMOG56" ||
        item.field == "DEMOG57"
      ) {
        portalReports = [...portalReports, item];
        sum3 += item.count;
      }

      if (
        item.field == "DEMOG41" ||
        item.field == "DEMOG42" ||
        item.field == "DEMOG43" ||
        item.field == "DEMOG44"
      ) {
        item.field_description = "Of Hispanic, Latino/a or Spanish origin";
        portalReports = [...portalReports, item];
        sum3 += item.count;
      }
    }
    let portal_data = [];
    let duplicate_portal_reports = [];
    let list2 = portalReports;
    for (let item of list2) {
      if (!duplicate_portal_reports.includes(item.field_description)) {
        duplicate_portal_reports.push(item.field_description);
        portal_data.push(item);
      }
    }
    const other = [];
    for (let single of portal_data) {
      let total = 0;
      for (let inner of list2) {
        if (inner.field_description == single.field_description) {
          total += Number(inner.count);
        }
      }
      single.count = total;
      other.push(single);
    }

    setTotalOfPortalReport(sum3);
    const sum3OnePercent = Number(sum3 / 100);
    for (let d3 of other) {
      d3.percentage = (Number(d3.count) / Number(sum3OnePercent)).toFixed(2);
    }
    setPortalReports(other);
  };

  const portalPieData =
    portalReports &&
    portalReports.map((item, index) => {
      return {
        id: item.field_description + " (" + item.percentage + "%) ",
        label: item.field_description + " (" + item.percentage + "%) ",
        value: item.count,
        color: "#" + Math.floor(Math.random() * 0xffffff).toString(16),
      };
    });

  return (
    <div>
      <div className="row">
        <div
          className="col-lg-12 main-section add-user"
          style={{ paddingTop: 0 }}
        >
          <div
            className="wrapper clearfix position-relative"
            style={{
              paddingTop: 0,
              background: "#fff",
              transform: "scale(1)",
            }}
          >
            <div className="multisteps-form import-participant-block">
              <div className="bg-white" id="main-section">
                <div className="row bg-white" id="section-1">
                  <div className="col-12 col-lg-12" style={{ marginBottom: 40 }}>
                    <div className="wizard-content-form ethnicity-report-1 bg-white diagnosis-report">
                      <div
                        className="wizard-form-field ml-0"
                        style={{ margin: "0px 0 14px 14px" }}
                      >
                        <br />
                        <div
                          style={{
                            width: "95%",
                          }}
                          className="graph-outer"
                        >
                          <div className="main-download-button">
                            <h1
                              className="pt-4"
                              style={{
                                fontSize: 27,
                                fontWeight: "600",
                                marginTop: -40,
                                marginBottom: 50,
                              }}
                            >
                              All Participants Demographics Distribution -
                              <span className="">
                                (Total Participants - {totalOfPortalReport})
                              </span>
                            </h1>
                          </div>
                          <ResponsivePie
                            data={portalPieData}
                            margin={{
                              top: $(window).width() < 600 ? 0 : 40,
                              right: $(window).width() < 600 ? 100 : 0,
                              bottom: 80,
                              left: $(window).width() < 600 ? 60 : -130,
                            }}
                            startAngle={-18}
                            innerRadius={0.5}
                            padAngle={0.7}
                            activeOuterRadiusOffset={8}
                            colors={{ scheme: "set3" }}
                            borderWidth={1}
                            borderColor={{
                              from: "color",
                              modifiers: [["darker", 0.2]],
                            }}
                            arcLinkLabelsSkipAngle={10}
                            arcLinkLabelsTextColor="#333333"
                            arcLinkLabelsThickness={2}
                            arcLinkLabelsColor={{ from: "color" }}
                            arcLabelsSkipAngle={10}
                            arcLabelsTextColor={{
                              from: "color",
                              modifiers: [["darker", 2]],
                            }}
                            defs={[
                              {
                                id: "dots",
                                type: "patternDots",
                                background: "inherit",
                                color: "rgba(255, 255, 255, 0.3)",
                                size: 4,
                                padding: 1,
                                stagger: true,
                              },
                              {
                                id: "lines",
                                type: "patternLines",
                                background: "inherit",
                                color: "rgba(255, 255, 255, 0.3)",
                                rotation: -45,
                                lineWidth: 6,
                                spacing: 10,
                              },
                            ]}
                            fill={[
                              {
                                match: {
                                  id: "ruby",
                                },
                                id: "dots",
                              },
                              {
                                match: {
                                  id: "c",
                                },
                                id: "dots",
                              },
                              {
                                match: {
                                  id: "go",
                                },
                                id: "dots",
                              },
                              {
                                match: {
                                  id: "python",
                                },
                                id: "dots",
                              },
                              {
                                match: {
                                  id: "scala",
                                },
                                id: "lines",
                              },
                              {
                                match: {
                                  id: "lisp",
                                },
                                id: "lines",
                              },
                              {
                                match: {
                                  id: "elixir",
                                },
                                id: "lines",
                              },
                              {
                                match: {
                                  id: "javascript",
                                },
                                id: "lines",
                              },
                            ]}
                            legends={[
                              {
                                anchor: "right",
                                direction: "column",
                                justify: false,
                                translateX: $(window).width() < 600 ? 120 : 0,
                                translateY: $(window).width() < 600 ? 200 : 20,
                                itemsSpacing: 0,
                                itemWidth: 280,
                                itemHeight: $(window).width() < 600 ? 24 : 33,
                                itemTextColor: "#000",
                                itemDirection: "left-to-right",
                                itemOpacity: 1,
                                symbolSize: $(window).width() < 600 ? 18 : 23,
                                symbolShape: "circle",
                                effects: [
                                  {
                                    on: "hover",
                                    style: {
                                      itemTextColor: "#000",
                                    },
                                  },
                                ],
                              },
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllDemographics;
